import { render } from "./basic.vue?vue&type=template&id=1a0a08c9&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import "./basic.vue?vue&type=style&index=0&id=1a0a08c9&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0a08c9"]])

export default __exports__